import { useCallback, useEffect } from 'react'
import { type DataLayerCallbackProps, getDataLayer } from '@dhl/datalayer'
import { writePageLoad } from './writePageLoad.js'
import { writeContentEvent } from './writeContentEvent.js'
import { writePurchaseEvent } from './writePurchaseEvent.js'
import { type DataLayerData, type DataLayerMeta } from '../types/types.js'
import { writeEngagementEvent } from './writeEngagementEvent.js'
import { writeConversionEvent } from './writeConversionEvent.js'

// import { getDataLayer } from '../init-datalayer.js'

const determineEventBeforeWrite = (
  type: string,
  dataLayerEvent: DataLayerCallbackProps<DataLayerData, DataLayerMeta>
): void => {
  switch (type) {
    case 'Engagement':
      writeEngagementEvent(dataLayerEvent)
      break
    case 'Conversion':
      writeConversionEvent(dataLayerEvent)
      break
    case 'Purchase':
      writePurchaseEvent(dataLayerEvent)
      break
    default:
      writeContentEvent(dataLayerEvent)
      break
  }
}

export const useAdobeTracking = (isEnabled: boolean): void => {
  const initAdobe = useCallback(() => {
    getDataLayer<DataLayerData, DataLayerMeta>()?.subscribe((dataLayerEvent) => {
      switch (dataLayerEvent?.event) {
        case 'PAGE_LOAD':
          writePageLoad(dataLayerEvent)
          break
        case 'EVENT':
          determineEventBeforeWrite(dataLayerEvent.meta.type, dataLayerEvent)
          break
        default:
          break
      }
    })
  }, [])

  useEffect(() => {
    if (isEnabled) {
      initAdobe()
    }
  }, [isEnabled, initAdobe])
}
